import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'gamesFilter'
})
export class GamesFilterPipe implements PipeTransform {

  transform(values: any[], searchTerm: string, gameTypes: string, gameStates: string, intervals: string): any {
    if(values == undefined)
      return;

    var rawData = JSON.parse(JSON.stringify(values));
    
    var filteredGames = [];
    var filteredFolders = [];

    //Looping through folders
    for(var i = 0; i < rawData.length; i++){
      var currentFolder = rawData[i];
      filteredGames = [];

      //Looping through games
      for(var j = 0; j < currentFolder.Games.length; j++){

        var totalMatches = 0;
        var currentGame = currentFolder.Games[j];

        if (currentGame != null && currentGame.GameObject != null && currentGame.GameObject != undefined && currentGame.GameObject.underlyingRule != null) {
          //Matching game name
          if (currentGame.GameObject.underlyingRule.RuleName.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1) {
            totalMatches++;
            //if there are not matches, current game is skipped
          }else{
            continue;
          }

          //Matching game state
          if(gameStates[0] == "0" && gameStates[1] == "0"){
            totalMatches++;
          } else if(currentGame.GameObject.isActive && gameStates[0] == "1"){
            totalMatches++;
            //Matching inactive game state
          } else if(!currentGame.GameObject.isActive && gameStates[1] == "1"){
            totalMatches++;
            //if there are not matches, current game is skipped
          }else{
            continue;
          }

          //Matching game type - if every game type checkbox is selected, the game will have another match
          if(gameTypes.split('').every(function(type) { return type == "0" })){
            totalMatches++;
            //else if the type of the current game matches with the game type checkbox, the game will have another match
          } else if (gameTypes[currentGame.GameObject.underlyingRule.GameType - 1] == "1"){
            totalMatches++;
            //if there are not matches, current game is skipped
          } else{
            continue;
          }

          //Matching game interval - if every game interval checkbox is selected, the game will have another match
          if(intervals.split('').every(function(interval) { return interval == "0" })){
            totalMatches++;
            //else if the interval of the current game matched with the game interval checkbox, the game will have another match
          } else if((intervals[0] == "1" && currentGame.GameObject.underlyingRule.IntervalType == "Day") 
            || (intervals[1] == "1" && currentGame.GameObject.underlyingRule.IntervalType == "Week") 
            || (intervals[2] == "1" && currentGame.GameObject.underlyingRule.IntervalType == "Month")) {
            totalMatches++;
            //if there are not matches, current game is skipped
          }else{
            continue;
          }

          //If the game matches with every filter/checkbox, is included in the current folder
          if(totalMatches == 4){
            filteredGames.push(currentGame);
          }
        }
      }
      
      //If at least one game of the folder matches with filters, the current folder is included
      if(filteredGames.length > 0){
        currentFolder.Games = filteredGames;
        filteredFolders.push(currentFolder);
      }
    }

    return filteredFolders;
  }
}